<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <div class="page-layout-personal" :class="[{beakactive: beak}]">
    <div class="leftBlock" v-touch:swipe="swipeHandler">
      <div class="center align-center logo-personal">
        <ui-logo></ui-logo>
      </div>
      <div class="menu">
        <ul>
          <li @click="viewed=''; redirect(sitedir+'/personal/', '')" :class="[{ active: requesturl[2]=='' }]">
          <div class="item-icon">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path d="M6.55204 5.66671H1.23954C0.556023 5.66671 0 5.11069 0 4.42704V1.23954C0 0.556023 0.556023 0 1.23954 0H6.55204C7.23569 0 7.79171 0.556023 7.79171 1.23954V4.42704C7.79171 5.11069 7.23569 5.66671 6.55204 5.66671ZM1.23954 1.0625C1.14188 1.0625 1.0625 1.14188 1.0625 1.23954V4.42704C1.0625 4.52483 1.14188 4.60421 1.23954 4.60421H6.55204C6.64983 4.60421 6.72921 4.52483 6.72921 4.42704V1.23954C6.72921 1.14188 6.64983 1.0625 6.55204 1.0625H1.23954Z" fill="#95949C"/>
                <path d="M6.55204 17H1.23954C0.556023 17 0 16.4439 0 15.7604V8.32292C0 7.63927 0.556023 7.08325 1.23954 7.08325H6.55204C7.23569 7.08325 7.79171 7.63927 7.79171 8.32292V15.7604C7.79171 16.4439 7.23569 17 6.55204 17ZM1.23954 8.14575C1.14188 8.14575 1.0625 8.22513 1.0625 8.32292V15.7604C1.0625 15.8581 1.14188 15.9375 1.23954 15.9375H6.55204C6.64983 15.9375 6.72921 15.8581 6.72921 15.7604V8.32292C6.72921 8.22513 6.64983 8.14575 6.55204 8.14575H1.23954Z" fill="#95949C"/>
                <path d="M15.7605 17H10.448C9.76434 17 9.20831 16.4439 9.20831 15.7604V12.5729C9.20831 11.8893 9.76434 11.3333 10.448 11.3333H15.7605C16.444 11.3333 17 11.8893 17 12.5729V15.7604C17 16.4439 16.444 17 15.7605 17ZM10.448 12.3958C10.3502 12.3958 10.2708 12.4751 10.2708 12.5729V15.7604C10.2708 15.8581 10.3502 15.9375 10.448 15.9375H15.7605C15.8581 15.9375 15.9375 15.8581 15.9375 15.7604V12.5729C15.9375 12.4751 15.8581 12.3958 15.7605 12.3958H10.448Z" fill="#95949C"/>
                <path d="M15.7605 9.91671H10.448C9.76434 9.91671 9.20831 9.36069 9.20831 8.67704V1.23954C9.20831 0.556023 9.76434 0 10.448 0H15.7605C16.444 0 17 0.556023 17 1.23954V8.67704C17 9.36069 16.444 9.91671 15.7605 9.91671ZM10.448 1.0625C10.3502 1.0625 10.2708 1.14188 10.2708 1.23954V8.67704C10.2708 8.77483 10.3502 8.85421 10.448 8.85421H15.7605C15.8581 8.85421 15.9375 8.77483 15.9375 8.67704V1.23954C15.9375 1.14188 15.8581 1.0625 15.7605 1.0625H10.448Z" fill="#95949C"/>
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="17" height="17" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="item-title">
            <span>dashboard</span>
          </div>
        </li>
          <li @click="viewed='orders'; redirect(sitedir+'/personal/orders/', 'orders')" :class="[{ active: requesturl[2]=='orders' }]">
            <div class="item-icon">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.9967 4.19276C16.9768 4.00991 16.8632 3.84808 16.6934 3.76882L8.72462 0.0500737C8.58221 -0.0163657 8.41772 -0.0163657 8.27531 0.0500737L0.306564 3.76882C0.136764 3.84808 0.0231426 4.00988 0.00325391 4.19276C0.00282227 4.19658 0 4.24745 0 4.25024V13.2815C0 13.4987 0.132248 13.6941 0.333957 13.7747L8.30271 16.9622C8.36602 16.9876 8.43303 17.0002 8.5 17.0002C8.56697 17.0002 8.63397 16.9876 8.69729 16.9622L16.666 13.7747C16.8678 13.6941 17 13.4987 17 13.2815V4.25024C17 4.24745 16.9971 4.19655 16.9967 4.19276ZM8.5 1.11772L15.1321 4.21272L12.5783 5.23424L5.8214 2.36775L8.5 1.11772ZM4.52592 2.97231L11.178 5.79435L8.5 6.86555L1.86787 4.21272L4.52592 2.97231ZM1.0625 5.03489L7.96875 7.79739V15.6843L1.0625 12.9218V5.03489ZM9.03125 15.6843V7.79739L15.9375 5.03489V12.9218L9.03125 15.6843Z" fill="#95949C"/>
              </svg>
            </div>
            <div class="item-title">
              <span>orders</span>
            </div>
          </li>
          <li @click="viewed='promo'; redirect(sitedir+'/personal/promo/', 'promo')" :class="[{ active: requesturl[2]=='promo' }]">
            <div class="item-icon">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path d="M10.9154 4.75988C10.1787 3.57697 9.47746 2.46488 9.27205 1.06238C9.20829 0.594882 8.89663 0.212382 8.46454 0.0636323C8.05371 -0.0780343 7.60038 0.0282157 7.28163 0.332799C5.30538 2.2453 4.56871 4.49072 4.29954 6.09155C4.27829 6.02072 4.25704 5.94988 4.23579 5.87197C4.11538 5.45405 3.80371 5.1353 3.39996 5.01488C3.01746 4.90863 2.62079 5.00072 2.32329 5.25572C1.18288 6.26155 0.885378 7.8553 0.757878 8.96738C0.439128 11.7653 1.68579 14.3082 4.01621 15.6045C4.83079 16.0578 5.74454 16.2915 6.67246 16.2915C7.29579 16.2915 7.91913 16.1924 8.52829 15.9728C8.57788 15.6257 8.71246 15.307 8.92496 15.0166L9.68996 13.9965C9.60496 13.9682 9.51996 13.9328 9.43496 13.8903C9.07371 14.1807 8.67704 14.4074 8.23788 14.5774C7.04788 15.0378 5.75871 14.9599 4.70329 14.3649C2.86163 13.3378 1.91246 11.3757 2.16746 9.12322C2.29496 7.96863 2.55704 7.15405 2.98204 6.61572C3.27246 7.45155 3.71163 8.03947 4.43413 8.60613C4.65371 8.77613 4.95121 8.80447 5.19204 8.67697C5.43996 8.54947 5.58871 8.29447 5.58163 8.01822C5.49663 6.31822 6.07746 3.69738 7.94746 1.67863C8.25204 3.1803 8.9958 4.36322 9.7183 5.51072C10.3558 6.53072 10.9508 7.4728 11.1987 8.56363C11.815 8.69113 12.3462 9.01697 12.7429 9.4703C12.672 7.55072 11.7583 6.09155 10.9154 4.75988Z" fill="#95949C"/>
                  <path d="M10.625 12.7498C9.84369 12.7498 9.20831 12.1145 9.20831 11.3332C9.20831 10.5519 9.84369 9.9165 10.625 9.9165C11.4063 9.9165 12.0416 10.5519 12.0416 11.3332C12.0416 12.1145 11.4063 12.7498 10.625 12.7498Z" fill="#95949C"/>
                  <path d="M14.875 17.0001C14.0937 17.0001 13.4583 16.3647 13.4583 15.5834C13.4583 14.8021 14.0937 14.1667 14.875 14.1667C15.6563 14.1667 16.2916 14.8021 16.2916 15.5834C16.2916 16.3647 15.6563 17.0001 14.875 17.0001Z" fill="#95949C"/>
                  <path d="M10.6243 17.0001C10.4769 17.0001 10.3275 16.9541 10.2 16.8585C9.8869 16.624 9.82386 16.1799 10.0583 15.8668L14.3083 10.2001C14.5435 9.88777 14.9869 9.82331 15.3 10.0585C15.6131 10.2929 15.6761 10.7371 15.4417 11.0501L11.1917 16.7168C11.0528 16.9024 10.8396 17.0001 10.6243 17.0001Z" fill="#95949C"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="17" height="17" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="item-title">
              <span>promo</span>
            </div>
          </li>
          <li @click="viewed='address-book'; redirect(sitedir+'/personal/address-book/', 'address-book')" :class="[{ active: requesturl[2]=='address-book' }]">
            <div class="item-icon">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.00985 6.7934C4.00985 8.34655 5.27338 9.61008 6.82653 9.61008C7.19267 9.61008 7.4893 9.90683 7.4893 10.2728C7.4893 10.639 7.19267 10.9356 6.82653 10.9356C4.54253 10.9356 2.68432 9.0774 2.68432 6.7934C2.68432 4.50926 4.54253 2.65106 6.82653 2.65106C9.11067 2.65106 10.9689 4.50926 10.9689 6.7934C10.9689 7.15941 10.6721 7.45616 10.3061 7.45616C9.9401 7.45616 9.64335 7.15941 9.64335 6.7934C9.64335 5.24025 8.37968 3.97658 6.82653 3.97658C5.27338 3.97658 4.00985 5.24025 4.00985 6.7934ZM4.53059 12.6554C2.82984 10.7931 1.36113 9.18454 1.35879 6.78691C1.36229 3.77555 3.81517 1.32553 6.82653 1.32553C9.83802 1.32553 12.2908 3.77555 12.2943 6.78691C12.2948 7.15279 12.5914 7.44903 12.957 7.4489H12.9578C13.3238 7.44851 13.6203 7.15137 13.6198 6.78536C13.6177 4.97242 12.9102 3.26843 11.6275 1.98713C10.3448 0.705695 8.63973 0 6.82653 0C5.01346 0 3.30843 0.705695 2.02558 1.98713C0.74298 3.26843 0.0353394 4.97242 0.0332642 6.78678C0.0345612 8.10751 0.401351 9.34666 1.15478 10.575C1.80703 11.6387 2.65449 12.5667 3.55175 13.5493C4.43137 14.5127 5.34108 15.5088 6.06753 16.6582C6.1936 16.8577 6.40851 16.9669 6.62835 16.9669C6.74949 16.9669 6.87193 16.9338 6.98191 16.8643C7.29125 16.6687 7.38359 16.2594 7.188 15.9499C6.39891 14.7016 5.44912 13.6614 4.53059 12.6554ZM16.8264 12.9734C16.6956 13.1165 16.5166 13.189 16.3371 13.189C16.1773 13.189 16.0172 13.1317 15.8901 13.0155L15.8071 12.9396V15.1327C15.8071 16.1624 14.97 17 13.9412 17H10.2167C9.18797 17 8.35089 16.1624 8.35089 15.1327V12.9699L8.30109 13.0155C8.03092 13.2625 7.61173 13.2437 7.36466 12.9736C7.11771 12.7034 7.13651 12.2841 7.40668 12.0371L10.8275 8.90957C11.5504 8.24876 12.6407 8.24876 13.3635 8.90957L15.5553 10.9136C15.5796 10.9328 15.6024 10.9536 15.6237 10.9759L16.7845 12.0371C17.0546 12.2841 17.0734 12.7034 16.8264 12.9734ZM14.4815 11.7277L12.4691 9.8879C12.2561 9.69322 11.935 9.69322 11.722 9.8879L9.67642 11.7579V15.1327C9.67642 15.4314 9.91883 15.6744 10.2169 15.6744H13.9412C14.2391 15.6744 14.4815 15.4314 14.4815 15.1327V11.7277Z" fill="#95949C"/>
              </svg>
            </div>
            <div class="item-title">
              <span>Address book</span>
            </div>
          </li>
          <li @click="viewed='payment-methods'; redirect(sitedir+'/personal/payment-methods/', 'payment-methods')" :class="[{ active: requesturl[2]=='payment-methods' }]">
            <div class="item-icon">
              <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.177063 2.14873C0.177063 1.13949 0.980951 0.302002 1.99619 0.302002H13.5871C14.6023 0.302002 15.4062 1.13949 15.4062 2.14873V5.79159C15.4062 6.08498 15.1684 6.32284 14.875 6.32284C14.5816 6.32284 14.3437 6.08498 14.3437 5.79159V2.14873C14.3437 1.70493 13.9944 1.3645 13.5871 1.3645H1.99619C1.58888 1.3645 1.23956 1.70493 1.23956 2.14873V8.72614C1.23956 9.16991 1.58888 9.51034 1.99619 9.51034H7.08331C7.37671 9.51034 7.61456 9.74819 7.61456 10.0416C7.61456 10.335 7.37671 10.5728 7.08331 10.5728H1.99619C0.980951 10.5728 0.177063 9.73537 0.177063 8.72614V2.14873Z" fill="#95949C"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.177063 2.95825C0.177063 2.66485 0.414911 2.427 0.708313 2.427H14.875C15.1684 2.427 15.4062 2.66485 15.4062 2.95825C15.4062 3.25165 15.1684 3.4895 14.875 3.4895H0.708313C0.414911 3.4895 0.177063 3.25165 0.177063 2.95825Z" fill="#95949C"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.59375 6.49976C1.59375 6.20636 1.8316 5.96851 2.125 5.96851H3.54167C3.83507 5.96851 4.07292 6.20636 4.07292 6.49976C4.07292 6.79315 3.83507 7.03101 3.54167 7.03101H2.125C1.8316 7.03101 1.59375 6.79315 1.59375 6.49976Z" fill="#95949C"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.59375 8.27075C1.59375 7.97736 1.8316 7.7395 2.125 7.7395H4.95833C5.25173 7.7395 5.48958 7.97736 5.48958 8.27075C5.48958 8.56414 5.25173 8.802 4.95833 8.802H2.125C1.8316 8.802 1.59375 8.56414 1.59375 8.27075Z" fill="#95949C"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.67706 10.7499C8.67706 8.50054 10.5006 6.677 12.75 6.677C14.9994 6.677 16.8229 8.50054 16.8229 10.7499C16.8229 12.9993 14.9994 14.8228 12.75 14.8228C10.5006 14.8228 8.67706 12.9993 8.67706 10.7499ZM14.5423 10.7714C14.7497 10.5639 14.7497 10.2276 14.5423 10.0201C14.3348 9.81265 13.9985 9.81265 13.791 10.0201L12.75 11.0611L12.0631 10.3743C11.8556 10.1668 11.5193 10.1668 11.3119 10.3743C11.1044 10.5818 11.1044 10.9181 11.3119 11.1255L12.3744 12.188C12.5818 12.3955 12.9181 12.3955 13.1256 12.188L14.5423 10.7714Z" fill="#95949C"/>
              </svg>
            </div>
            <div class="item-title">
              <span>Payment methods</span>
            </div>
          </li>
          <li @click="viewed='notification-preferences'; redirect(sitedir+'/personal/notification-preferences/', 'notification-preferences')" :class="[{ active: requesturl[2]=='notification-preferences' }]">
            <div class="item-icon">
              <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.9472 13.5287C13.8972 13.4963 13.5211 13.2328 13.1445 12.4358C12.4529 10.9721 12.3078 8.91026 12.3078 7.43833C12.3078 7.43192 12.3076 7.42558 12.3074 7.41921C12.2998 5.47387 11.135 3.79691 9.46805 3.04449V1.89377C9.46805 0.849535 8.61991 0 7.5774 0H7.42072C6.3782 0 5.53006 0.849535 5.53006 1.89377V3.04443C3.85755 3.79927 2.69036 5.48479 2.69036 7.43833C2.69036 8.91026 2.5452 10.9721 1.85361 12.4358C1.47706 13.2328 1.10096 13.4962 1.05096 13.5287C0.840386 13.6262 0.73656 13.8513 0.785003 14.0794C0.833912 14.3098 1.04927 14.4687 1.28444 14.4687H4.93503C4.95542 15.8679 6.0974 17 7.49907 17C8.90074 17 10.0427 15.8679 10.0631 14.4687H13.7137C13.9488 14.4687 14.1642 14.3098 14.2131 14.0794C14.2615 13.8513 14.1577 13.6261 13.9472 13.5287ZM6.52619 1.89377C6.52619 1.39968 6.92748 0.997721 7.42075 0.997721H7.57743C8.0707 0.997721 8.47199 1.39968 8.47199 1.89377V2.7211C8.15763 2.65612 7.8322 2.62192 7.49894 2.62192C7.16578 2.62192 6.84046 2.65608 6.52622 2.721V1.89377H6.52619ZM7.49907 16.0023C6.64665 16.0023 5.95134 15.3177 5.93112 14.4687H9.06699C9.0468 15.3177 8.3515 16.0023 7.49907 16.0023ZM9.50454 13.4709C9.50444 13.4709 2.41949 13.4709 2.41949 13.4709C2.50566 13.3366 2.59335 13.1846 2.6805 13.0128C3.34802 11.6965 3.68649 9.82099 3.68649 7.43833C3.68649 5.33269 5.39675 3.61964 7.49891 3.61964C9.60106 3.61964 11.3113 5.33269 11.3113 7.43999C11.3113 7.44613 11.3114 7.45224 11.3117 7.45835C11.3135 9.83145 11.652 11.7002 12.3176 13.0128C12.4048 13.1846 12.4925 13.3366 12.5787 13.4709H9.50454Z" fill="#95949C"/>
              </svg>
            </div>
            <div class="item-title">
              <span>Notification preferences</span>
            </div>
          </li>
          <li @click="viewed='loyalty-program'; redirect(sitedir+'/personal/loyalty-program/', 'loyalty-program')" :class="[{ active: requesturl[2]=='loyalty-program' }]">
            <div class="item-icon">
              <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.6786 6.69743C15.9864 6.39737 16.0951 5.957 15.9623 5.54817C15.8294 5.13934 15.4826 4.84699 15.0572 4.78519L11.3375 4.24468C11.2645 4.23409 11.2014 4.18824 11.1687 4.12203L9.50518 0.751414C9.31495 0.365926 8.92973 0.126465 8.49985 0.126465C8.06997 0.126465 7.68475 0.365926 7.49453 0.751414L5.83102 4.12206C5.79831 4.18824 5.73523 4.23409 5.66218 4.24471L1.9425 4.78519C1.5171 4.84699 1.17036 5.13934 1.03748 5.54817C0.904603 5.957 1.01331 6.39737 1.32117 6.69743L4.01278 9.32111C4.06561 9.37264 4.08975 9.44685 4.07726 9.5196L3.44185 13.2243C3.3692 13.648 3.54007 14.0681 3.88784 14.3208C4.23561 14.5735 4.6881 14.6061 5.06854 14.4062L8.39553 12.6571C8.46087 12.6227 8.53886 12.6227 8.60424 12.6571L11.9313 14.4062C12.0967 14.4932 12.2758 14.5362 12.454 14.5361C12.6854 14.5361 12.9154 14.4636 13.1119 14.3207C13.4596 14.068 13.6305 13.6479 13.5578 13.2242L12.9224 9.51956C12.91 9.44681 12.9341 9.37261 12.9869 9.32107L15.6786 6.69743ZM12.0385 9.67123L12.6739 13.376C12.6952 13.5 12.6187 13.5706 12.5848 13.5952C12.5508 13.6198 12.4599 13.6708 12.3486 13.6123L9.02161 11.8632C8.85828 11.7773 8.67911 11.7344 8.49992 11.7344C8.32072 11.7344 8.14152 11.7773 7.97823 11.8631L4.65124 13.6122C4.53988 13.6707 4.449 13.6198 4.4151 13.5952C4.3812 13.5706 4.30464 13.4999 4.32592 13.3759L4.96133 9.67123C5.02372 9.30749 4.90322 8.93655 4.63889 8.67893L1.94728 6.05525C1.8572 5.96739 1.87759 5.86523 1.89057 5.82538C1.90349 5.78551 1.94708 5.69084 2.07156 5.67278L5.79121 5.13227C6.15641 5.07921 6.472 4.84997 6.63536 4.51897L8.29887 1.14832C8.35455 1.03553 8.45802 1.02335 8.49995 1.02335C8.54182 1.02335 8.64528 1.0355 8.701 1.14832V1.14836L10.3645 4.51901C10.5278 4.85001 10.8434 5.07924 11.2086 5.1323L14.9283 5.67281C15.0528 5.69088 15.0963 5.78554 15.1093 5.82542C15.1222 5.86529 15.1427 5.96749 15.0526 6.05528L12.3609 8.67896C12.0966 8.93655 11.9762 9.30749 12.0385 9.67123Z" fill="#95949C"/>
              </svg>
            </div>
            <div class="item-title">
              <span>loyalty program</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="menu back">
        <ul>
          <li @click="urlMain()">
            <div class="item-icon">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.7164 8.94676C15.8033 6.00892 12.9051 4.00405 9.43135 3.94449V0.5104C9.43135 0.351598 9.2924 0.212646 9.1336 0.212646C9.07405 0.212646 9.0145 0.232497 8.95495 0.272197L0.121583 6.66398C-0.017369 6.76323 -0.0372192 6.94188 0.0620321 7.08084C0.0818823 7.10069 0.101733 7.12054 0.121583 7.14039L8.95495 13.4925C9.0939 13.5917 9.27255 13.552 9.3718 13.4329C9.4115 13.3734 9.43135 13.3138 9.43135 13.2543V9.84002C11.5752 9.84002 13.3816 10.8524 14.0168 12.3809C14.5527 13.691 14.116 15.1003 12.8456 16.2715C12.7265 16.3906 12.7066 16.5693 12.8257 16.6884C12.8853 16.7479 12.9647 16.7876 13.0441 16.7876H13.2823C13.3419 16.7876 13.4014 16.7678 13.4411 16.7281C16.3591 14.8026 17.6097 11.8052 16.7164 8.94676Z" fill="#95949C"/>
              </svg>
            </div>
            <div class="item-title">
              <span>back to website</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="rightBlock" v-touch:swipe="swipeHandler">
      <layout-header-personal :authorized="authorized" :sitedir="sitedir" :siteid="siteid"></layout-header-personal>

      <div v-if="requesturl[2]==''">
        <div class="great-title">
          <h1>PERSONAL SECTION</h1>
        </div>
        dashboard in developing
      </div>

      <section-orders v-if="requesturl[2]=='orders'"></section-orders>

      <div v-if="viewed=='promo'"> <!--  v-if="requesturl[2]=='promo'" -->
        <div class="great-title">
          <h1>PERSONAL SECTION promo</h1>
        </div>
        promo in developing
      </div>

      <div v-if="requesturl[2]=='address-book'">
        <div class="great-title">
          <h1>PERSONAL SECTION address-book</h1>
        </div>
        address-book in developing
      </div>

      <div v-if="requesturl[2]=='payment-methods'">
        <div class="great-title">
          <h1>PERSONAL SECTION payment-methods</h1>
        </div>
        payment-methods in developing
      </div>

      <div v-if="requesturl[2]=='notification-preferences'">
        <div class="great-title">
          <h1>PERSONAL SECTION notification-preferences</h1>
        </div>
        notification-preferences in developing
      </div>

      <div v-if="requesturl[2]=='loyalty-program'">
        <div class="great-title">
          <h1>PERSONAL SECTION loyalty-program</h1>
        </div>
        loyalty-program in developing
      </div>


    </div>
    <!--  -->
  </div>
</template>

<script>
  import layoutHeaderPersonal from '@/components/layout/layout-header-personal'
  import uiLogo from '@/components/ui/ui-logo'
  import sectionOrders from '@/components/sections/section-orders'
export default {
  components: {
    layoutHeaderPersonal,
    uiLogo,
    sectionOrders
  },
  props: {
    requesturl: null,
    phone: null,
    clearcacheurl: null,
    admin: {
        type: Boolean,
        default() {
            return false
        }
    },
    authorized: {
      type: Boolean,
      default() {
          return false
      }
    },
    sitedir: {
        type: String,
        default() {
            return "/"
        }
    },
    siteid: {
        type: String,
        default() {
            return "s1"
        }
    },
    user: {},
    flex: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      adminshtuchki:'',
      beak: false,
      ops: {
          vuescroll: {},
          scrollPanel: {},
          rail: {
              background: '#000',
              opacity: 0.1,
              size: '3px',
              specifyBorderRadius: '0px'
          },
          bar: {
              background: '#000',
              opacity: 1,
              size: '3px'
          }
      },
      viewed: ''
    }
  },
  mounted() {},
  created(){
      this.viewed=this.requesturl[2];
  },
  methods: {
      urlMain(){
        location.href = this.$store.state.langs.SITE_DIR+"/";
      },
      redirect(url, page){
          //location.href = url;
          window.history.replaceState({}, '', `${url}`);
          this.requesturl[2] = page;
          //return true;
      },
      swipeHandler (direction) {
          if(direction == "left"){
              this.beak = false;
          }
          if(direction == "right"){
              this.beak = true;
          }
          // May be left / right / top / bottom
      },
      beakLeft(){
          this.beak = !this.beak;
      }
  }
}
</script>

<style lang="scss" scoped>
.page-layout-personal {

  position: relative;
  overflow: hidden;
  height: 100vh;
  min-height: 100vh;
  background: #000;
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  width: 100vw;
}
.page-layout-personal .leftBlock {
  color: #fff;
  width: 320px;
  max-width: 320px;
}
.page-layout-personal .leftBlock .menu{
  padding: 0 20px;
}
.page-layout-personal .leftBlock .menu ul{
  list-style: none;
}
.page-layout-personal .leftBlock .menu li{
  display: flex;
  height: 45px;
  align-items: center;
  cursor: pointer;
  padding: 0 20px;
}
.page-layout-personal .leftBlock .menu ul li .item-icon{
  width: 20px;
  text-align: right;
  height: 20px;
  display: flex;
  align-items: center;
}
.page-layout-personal .leftBlock .menu ul li .item-title{
  padding: 0 0 0 20px;
  height: 100%;
  width: 100%;
}
.page-layout-personal .leftBlock .menu ul li .item-title span{
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  text-align: left;
  height: 100%;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: #95949C;
  font-size: 13px;
  line-height: 120%;
}
.page-layout-personal .leftBlock .menu ul li:hover, .page-layout-personal .leftBlock .menu ul li.active{
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}
.page-layout-personal .leftBlock .menu ul li:hover svg path, .page-layout-personal .leftBlock .menu ul li.active svg path{
  fill: #fff;
}
.page-layout-personal .leftBlock .menu ul li:hover .item-title span, .page-layout-personal .leftBlock .menu ul li.active .item-title span{
  color: #fff;
}
.page-layout-personal .leftBlock .menu.back{
  position: absolute;
  bottom: 15px;
}
.page-layout-personal .leftBlock .menu.back ul li .item-title span{
  border-bottom: none;
}
.page-layout-personal .leftBlock .menu.back ul li:hover .item-title span{
  color: #fff;
}
.page-layout-personal .leftBlock .menu.back ul li:hover{
  background: none;
  border-radius: 0;
}
.page-layout-personal .rightBlock{
  background: #fff;
  border-radius: 15px;
  margin: 5px 0px;
  width: 100%;
  padding: 0 20px 0 40px;
}
.page-layout-personal .logo-personal{
  margin-top: 13vh;
  margin-bottom: 15vh;
}
.bloader, .bloader:before, .bloader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out; }
.bloader {
  color: #a39f9e;
  font-size: 10px;
  margin: 80px auto;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s; }
.bloader:before, .bloader:after {
  content: '';
  position: absolute;
  top: 0; }
.bloader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s; }
.bloader:after {
  left: 3.5em; }
@-webkit-keyframes load7 {
  0%, 80%, 100% {
    -webkit-box-shadow: 0 2.5em 0 -1.3em;
    box-shadow: 0 2.5em 0 -1.3em; }
  40% {
    -webkit-box-shadow: 0 2.5em 0 0;
    box-shadow: 0 2.5em 0 0; } }
@keyframes load7 {
  0%, 80%, 100% {
    -webkit-box-shadow: 0 2.5em 0 -1.3em;
    box-shadow: 0 2.5em 0 -1.3em; }
  40% {
    -webkit-box-shadow: 0 2.5em 0 0;
    box-shadow: 0 2.5em 0 0; }
}
.adminshtucki{
  position: fixed;
  top: 0;
  left: 0;
  display: inline-block;
  z-index: 100000;
  padding: 5px;
  border-radius: 8px;
  cursor: pointer;
  width: 250px;
  height: 25px;
}
.page-layout-personal .beak{
  position: absolute;
  left: -6px;
  z-index: 154;
  top: 50%;
}
.page-layout-personal .beak svg{
  transform: rotate(270deg);
  width: 28px;
  height: 15px;
}
@media screen and (max-width: 767px) {
  .page-layout-personal .leftBlock{
    width: 1px;
    transition: width 1s;
  }
  .page-layout-personal.beakactive .leftBlock{
    width: 260px;
  }
  .page-layout-personal .rightBlock {
    margin-right: 1px;
  }
}

</style>
<style>
  .page-layout-personal .logo-personal .ui-logo svg path{
    fill: #ffffff !important;
  }
</style>
